import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { SalaryscaleService } from '../../services';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  @Input() childMessage: string;

  constructor(private scale_service: SalaryscaleService, private router: Router) { }

  menuOpen = false;
  is_ja_enabled = false;
  scalesList: any = [];
  uniqueArray: any = [];
  Updateslength = 0;

  ngOnInit() {
    this.loadlatestScaleInfo();
  }

  loadlatestScaleInfo() {
    this.scale_service.getlatestScaleData(30).subscribe((res: any) => {
      this.scalesList = res.data;
      if (this.scalesList.length > 1) {
        var filterLength = this.removeDuplicates(this.scalesList);
        this.uniqueArray = filterLength.filter((item, index) => index < 10)
        this.Updateslength = this.uniqueArray.length;
      }
    })
  }

  removeDuplicates(originalArray) {
    // var newArray = [];
    // var lookupObject = {};
    // for (var i in originalArray) {
    //   lookupObject[originalArray[i][prop]] = originalArray[i];
    // }
    // for (i in lookupObject) {
    //   newArray.push(lookupObject[i]);
    // }
    // return newArray;
    return originalArray.filter((v, i, a) => a.findIndex(ele => (ele.dutyStationId === v.dutyStationId)) === i)
  }

  viewScale(_id) {
    const url = this.router.serializeUrl(
      this.router.createUrlTree(["/viewdutystation/" + _id])
    );
    window.open('#' + url, '_blank');
  }
}
